import React from 'react';
import { setSubjectAction } from '../../../redux/slices/oldBuilder';
import { subjectTooltipOption } from '../../KubitTooltip/globalTooltips';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../redux/selectors/builder';
import { assertCondition } from '../../../utils/types';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import BuilderEnumSelect from '../BuilderFields/BuilderEnumSelect';

interface IProps {
  queryType:
    | QueryType.Path
    | QueryType.Funnel
    | QueryType.Retention
    | QueryType.Significance;
  onChange?: (selectedSubject: string) => void;
}

export default ({ queryType, onChange }: IProps) => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === queryType && selectedOptions?.type === queryType,
  );

  const selectedSubject = selectedOptions.subject;
  const subjects = defaultOptions.subjects;

  const handleChange = (subjectKey: string) => {
    dispatch(
      setSubjectAction({
        queryType,
        subjectKey,
      }),
    );

    if (onChange) {
      onChange(subjectKey);
    }
  };

  return (
    <BuilderEnumSelect
      label={'Subject'}
      enumOptions={subjects}
      selectedOption={selectedSubject || ''}
      onChange={handleChange}
      tooltipOption={subjectTooltipOption}
    />
  );
};
